import { Component, OnInit } from '@angular/core';
import { CrudService } from '../crud.service';
@Component({
  selector: 'app-best-bba-courses',
  templateUrl: './best-bba-courses.component.html',
  styleUrls: ['./best-bba-courses.component.scss']
})
export class BestBbaCoursesComponent implements OnInit {

  constructor(private crudService: CrudService) { }
  baseUrl = this.crudService.baseUrl;

  ngOnInit(): void {
  }

}
